import Behaviour, { mix, DomEvents } from '@/core'

/**
 *
 * @extends Behaviour
 * @class MobileMenu
 */
export default class SelectChange extends mix(Behaviour).with(DomEvents) {
	constructor(el) {
		super(el)

		this.addDomEvents()
	}

	events = {
		'change .nav__select': 'selectChangeHandler'
	}

	selectChangeHandler = (e, $el) => {
		log(e, $el)
		const url = $el.value // get selected value
		if (url) window.location = url // redirect
		return false
	}
}
